module.exports = __webpack_public_path__ + "img/bussiness.6d56f9b9.jpg";